module.exports = __webpack_public_path__ + "img/complex-residence-mini.7fe07799.png";